<div *ngIf="!isLoading && (data && !data.length) && !isError" class="estado-vazio-listas ion-padding">
  <ion-grid>
    <ion-row>
      <ion-col>
        <img src="../../../../assets/imgs/nuvem-animada.svg" width="150"/>
      </ion-col>
    </ion-row>
    <ion-row  class="ion-align-items-center ion-justify-content-center">
      {{ emptyText }}
      <p>{{ emptyTextEstacao }}</p>
    </ion-row>
  </ion-grid>
</div>
